import { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getExamReport } from "../../endpoints/Assessment/functions";
import LocalReportContent from "../../components/Report/Exams/LocalReportContent";
import ExamReportContent from "../../components/Report/Exams/ReportContent";

const ExamReport = (props) => {
  const { examId } = useParams();
  const location = useLocation();
  const isExamIdNumber = !isNaN(Number(examId));
  const { score, name } = location.state || { score: 0, name: "" };

  const [report, setReport] = useState(null);

  const getEvaluationReport = useCallback(
    async (examId) => {
      if (props.token && isExamIdNumber) {
        try {
          let response = await getExamReport(examId, props.token);
          setReport(response);
        } catch (error) {
          console.warn("Error getting report", error);
        }
      }
    },
    [props.token, isExamIdNumber],
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getEvaluationReport(examId);
      } catch (error) {
        console.log("Error at ExamReport mount", error);
      }
    };
    fetchData();
  }, [examId, getEvaluationReport]);

  return (
    <div className="page page-col">
      {props.token && isExamIdNumber ? (
        <ExamReportContent report={report} />
      ) : (
        <LocalReportContent name={name} score={score} />
      )}
    </div>
  );
};

export default ExamReport;
